import React, { useState } from 'react';
import { Typography, Popover, Box, Checkbox } from '@material-ui/core';
import style from '../../../styles/sass/components/FavoritesDialog.module.scss';
import { HeartStraight } from 'phosphor-react';
import Link from 'next/link';
import { connect } from 'react-redux';
import {
  setShowFavoritesModal,
  unsetShowFavoritesModal,
} from '../../../actions/favorite';
import { isMobile } from '../../../lib/getDeviceSize';
import { createStyles, makeStyles } from '@material-ui/core/styles';

/**
 * @function FavoritesDialog
 */

export interface Props {
  dispatch: any;
  currentComponent: any;
  pointToSidebar?: boolean;
}

const useStyles = makeStyles(
  createStyles({
    leftArrow: {
      position: 'fixed',
      left: '82px',
      top: '201px',
      width: 0,
      height: 0,
      borderTop: '8px solid transparent',
      borderRight: '8px solid white',
      borderBottom: '8px solid transparent',
    },
  }),
);

const FavoritesDialog = (props: Props) => {
  const [anchorElement, setAnchor] = useState(props.currentComponent);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const classes = useStyles();

  const handleDontShow = (event: any) => {
    setDontShowAgain(event.target.checked);
    if (event.target.checked) props.dispatch(unsetShowFavoritesModal());
    else props.dispatch(setShowFavoritesModal());
  };

  const popoverPosition = isMobile()
    ? {
        anchorReference: 'anchorPosition' as const,
        anchorPosition: { top: 750, left: 37 },
        anchorOrigin: {
          vertical: 'center' as const,
          horizontal: 'center' as const,
        },
        transformOrigin: {
          vertical: 'top' as const,
          horizontal: 'left' as const,
        },
      }
    : {
        anchorOrigin: {
          vertical: 'bottom' as const,
          horizontal: 'right' as const,
        },
        transformOrigin: {
          vertical: 'top' as const,
          horizontal: 'right' as const,
        },
      };

  const popoverPositionSidebar = {
    anchorReference: 'anchorPosition' as const,
    anchorPosition: { top: 190, left: 90 },
    anchorOrigin: {
      vertical: 'center' as const,
      horizontal: 'center' as const,
    },
    transformOrigin: {
      vertical: 'top' as const,
      horizontal: 'left' as const,
    },
  };

  return (
    <Popover
      className={style.popover_class}
      anchorEl={anchorElement}
      open={Boolean(anchorElement)}
      onClose={(e: any) => {
        e.stopPropagation();
        setAnchor(null);
      }}
      {...(props.pointToSidebar ? popoverPositionSidebar : popoverPosition)}
    >
      {props.pointToSidebar && <div className={classes.leftArrow} />}
      <Box>
        <div className={style.mainBox}>
          <div className={style.boxContents}>
            <Typography className={style.mainHeading}>
              <HeartStraight
                style={{ paddingRight: 5 }}
                size={32}
                color="#463264"
                weight="duotone"
              />{' '}
              You favorited a property!
            </Typography>
            <Typography className={style.subText}>
              <Link href="/favorites">
                <a>Click here</a>
              </Link>{' '}
              to see your favorited homes.
            </Typography>
            <Typography className={style.optionText}>
              <Checkbox
                checked={dontShowAgain}
                onChange={handleDontShow}
                style={{ color: '#195A50' }}
              />{' '}
              Don’t show this message again
            </Typography>
          </div>
        </div>
      </Box>
    </Popover>
  );
};

const mapStateToProps = (state: any) => ({
  showFavoritesModal: state.favorites.showFavoritesModal,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(FavoritesDialog);
